<template>
  <span :class="className" v-html="iconSvg"></span>
</template>

<script>
import { icons } from './icons';

export default {
  props: ['icon', 'color', 'background'],
  data(self) {
    return {
      iconSvg: icons[self.icon] || '',
    };
  },
  computed: {
    className() {
      const baseClass = 'hvh-icon';
      const classes = [baseClass];
      classes.push(`${baseClass}--${this.icon}`);
      if (this.color) {
        classes.push(`${baseClass}--${this.color}`);
      }
      if (this.background) {
        classes.push(`${baseClass}--bg`);
      }
      return classes.join(' ');
    },
  },
};
</script>

<style lang="scss">
.hvh-icon {
  box-sizing: content-box;
  display: inline-block;

  path {
    fill: $color-black;
  }

  &.hvh-icon--bg {
    background: $color-gray-0;
  }
}

.hvh-icon--bg {
  border-radius: 8px;
  padding: rem(10px);
}

.hvh-icon--teal {
  path {
    fill: $color-teal;
  }

  &.hvh-icon--bg {
    background: $color-light-teal;
  }
}

.hvh-icon--cohort {
  height: 40px;
  width: 40px;
}

.hvh-icon--analysis {
  height: 40px;
  width: 40px;
}
</style>
